const ptBR = {
  pleaseEnterUsername: "Por favor, insira um nome de usuário",
  cannotFriendYourself: "Você não pode enviar uma solicitação de amizade para si mesmo.",
  friendRequestSent: "Solicitação de amizade enviada!",
  failedToSendRequest: "Falha ao enviar solicitação",
  linkCopied: "Link copiado para a área de transferência!",
  backToInvites: "Voltar para Convites",
  sendFriendRequestByUsername: "Enviar Solicitação de Amizade por Nome de Usuário",
  enterUsername: "Digite o nome de usuário",
  send: "Enviar",
  yourInviteQrCode: "Seu QR Code de Convite",
  inviteLink: "Link de Convite",
  scanQrOrUseLink: "Escaneie este QR code ou use este link para enviar uma solicitação de amizade",
  copyInviteLink: "Copiar link de convite",
  goToItem: "Ir para o item",
  verificationEmailSent: "E-mail de verificação enviado! Verifique sua caixa de entrada.",
  verificationEmailFailed: "Falha ao enviar o e-mail de verificação. Tente novamente.",
  verifyYourEmail: "Verifique Seu E-mail",
  verifyEmailInstructions: "Por favor, verifique seu endereço de e-mail para acessar sua conta. Verifique sua caixa de entrada para encontrar o link de verificação.",
  sending: "Enviando...",
  resendVerificationEmail: "Reenviar E-mail de Verificação",
  login: "Entrar",
  register: "Cadastrar-se",
  home: "Início",
  calendar: "Calendário",
  friends: "Amigos",
  profile: "Perfil",
  logout: "Sair",
  loading: "Carregando...",
  language: "Idioma",
  calendarSelectPlaceSuggestion: "Por favor, selecione um local nas sugestões para anexar as coordenadas.",
  calendarSelectDateAndTime: "Por favor, selecione uma data e um horário.",
  calendarPositiveDuration: "Por favor, informe uma duração positiva.",
  calendarFutureDateRequired: "A data e hora do evento devem estar no futuro.",
  calendarCreateEventFailed: "Falha ao criar o evento. Tente novamente.",
  cancel: "Cancelar",
  createNewEvent: "Criar Novo Evento",
  week: "Semana",
  month: "Mês",
  eventTitle: "Título",
  date: "Data",
  time: "Hora",
  duration: "Duração",
  endsAt: "Termina às",
  place: "Local",
  searchForPlace: "Pesquisar um local",
  placeSearchTip: "Dica: comece a digitar e selecione um resultado para anexar coordenadas.",
  description: "Descrição",
  createEvent: "Criar Evento",
  today: "Hoje",
  previousMonth: "Mês anterior",
  nextMonth: "Próximo mês",
  previous: "Anterior",
  next: "Próximo",
  mondayShort: "Seg",
  tuesdayShort: "Ter",
  wednesdayShort: "Qua",
  thursdayShort: "Qui",
  fridayShort: "Sex",
  saturdayShort: "Sáb",
  sundayShort: "Dom",
  more: "mais",
  mustRespondWillBeforeReposting: "Você deve responder \"Vou participar\" antes de republicar",
  event: "Evento",
  backToCalendar: "Voltar para o Calendário",
  addToGoogleCalendar: "Adicionar ao Google Agenda",
  when: "Quando",
  where: "Onde",
  openLocationInGoogleMaps: "Abrir localização no Google Maps",
  hosts: "Organizadores",
  yourResponse: "Sua Resposta",
  currentResponse: "Resposta Atual",
  response_will: "Vou participar",
  response_might: "Talvez participe",
  response_wont: "Não vou participar",
  willRunIntoYou: "Vou passar por lá",
  mightDropBy: "Talvez eu apareça",
  wontCome: "Não vou",
  repostToMyFriends: "Republicar para meus amigos",
  responses: "Respostas",
  willAttend: "Participará",
  reposted: "Republicado",
  mightAttend: "Talvez participe",
  cancelEvent: "Cancelar Evento",
  cancellationEmailNoticeBefore: "As pessoas que confirmaram presença",
  cancellationEmailNoticeAfter: "receberão um e-mail notificando o cancelamento.",
  optionalCancellationMessage: "Mensagem opcional para os participantes (máx. 1000 caracteres)",
  confirmCancelEvent: "Confirmar Cancelamento do Evento",
  clear: "Limpar",
  confirmCancellation: "Confirmar cancelamento",
  confirmCancellationMessage: "Tem certeza de que deseja cancelar este evento? Isso notificará os participantes confirmados e removerá o evento.",
  eventCancelledNotified: "Evento cancelado. Notificados:",
  attendees: "participantes",
  failedToCancelEvent: "Falha ao cancelar o evento",
  back: "Voltar",
  cancelled: "Cancelado",
  ok: "OK",
  forgotPassword: "Esqueceu a senha",
  email: "E-mail",
  passwordResetLinkSent: "Se a conta existir, um link de redefinição foi enviado.",
  passwordResetRequestFailed: "Falha ao solicitar redefinição de senha.",
  sendResetLink: "Enviar Link de Redefinição",
  addFriend: "Adicionar Amigo",
  incomingRequests: "Solicitações Recebidas",
  accept: "Aceitar",
  deny: "Recusar",
  myFriends: "Meus Amigos",
  noFriendsYet: "Você ainda não tem amigos. Comece a adicionar alguns!",
  seeProfile: "Ver Perfil",
  noEventsToRespondTo: "Não há eventos para responder",
  allCaughtUp: "Você está em dia. Volte mais tarde para novos eventos dos seus amigos.",
  events: "Eventos",
  unknown: "Desconhecido",
  noDescriptionProvided: "Nenhuma descrição fornecida.",
  will: "Sim",
  maybe: "Talvez",
  wont: "Não",
  userNotFound: "Usuário não encontrado",
  friendRequestSentSuccessfully: "Solicitação de amizade enviada com sucesso!",
  friendInvitation: "Convite de Amizade",
  sendFriendRequest: "Enviar Solicitação de Amizade",
  loginToSendFriendRequest: "Faça login para enviar uma solicitação de amizade",
  chooseLanguage: "Escolher Idioma",
  invalidCredentials: "Credenciais inválidas. Tente novamente.",
  username: "Nome de usuário",
  password: "Senha",
  forgotPasswordQuestion: "Esqueceu a senha?",
  dontHaveAccount: "Não tem uma conta?",
  registerHere: "Cadastre-se aqui",
  invalidProfilePhotoType: "Tipo de arquivo inválido. Envie uma imagem JPEG, PNG, GIF ou WebP.",
  invalidFileExtension: "Extensão de arquivo inválida",
  allowedExtensions: "Permitidas",
  fileTooLarge: "Arquivo muito grande",
  maximumFileSize: "Máximo",
  profilePhotoRemoved: "Foto de perfil removida.",
  failedToRemoveProfilePhoto: "Falha ao remover foto de perfil",
  profileUpdatedSuccessfully: "Perfil atualizado com sucesso!",
  failedToUpdateProfile: "Falha ao atualizar perfil",
  privateEmailExplanation: "Somente você pode ver seu e-mail para evitar mensagens indesejadas fora da plataforma",
  yourEmailIsPrivate: "Seu e-mail é privado.",
  profilePhoto: "Foto de Perfil",
  removePhoto: "Remover Foto",
  firstName: "Nome",
  lastName: "Sobrenome",
  tellPeopleAboutYourself: "Fale um pouco sobre você",
  whereToContactMe: "Onde Me Encontrar",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Salvar",
  notSet: "Não definido",
  editProfile: "Editar Perfil",
  imageToCrop: "Imagem para recortar",
  zoom: "Zoom",
  usePhoto: "Usar Foto",
  name: "Nome",
  whereToContact: "Contato",
  removeFriendship: "Remover Amizade",
  confirmRemoveFriend: "Confirmar remoção de amigo",
  confirmRemoveFriendBefore: "Tem certeza de que deseja remover",
  confirmRemoveFriendAfter: "da sua lista de amigos?",
  friendRemoved: "Amigo removido.",
  failedToRemoveFriend: "Falha ao remover amigo.",
  confirmRemove: "Confirmar Remoção",
  error: "Erro",
  removed: "Removido",
  passwordsDoNotMatch: "As senhas não coincidem",
  registrationFailed: "Falha no cadastro. Tente novamente.",
  confirmPassword: "Confirmar Senha",
  alreadyHaveAccount: "Já possui uma conta?",
  loginHere: "Entre aqui",
  passwordResetSuccessfully: "Senha redefinida com sucesso.",
  failedToResetPassword: "Falha ao redefinir senha.",
  resetPassword: "Redefinir Senha",
  newPassword: "Nova Senha",
  confirmNewPassword: "Confirmar Nova Senha",
  setNewPassword: "Definir Nova Senha",
  emailVerifiedSuccessfully: "E-mail verificado com sucesso!",
  emailVerificationFailed: "A verificação falhou. O link pode ser inválido ou ter expirado.",
  verifying: "Verificando...",
  verified: "Verificado!",
  redirectingToHome: "Redirecionando para a página inicial...",
  verificationFailed: "Falha na Verificação",
  goToHome: "Ir para a Página Inicial",
  about: "Sobre",
  aboutConceptTitle: "Conceito",
  aboutCreatorIntroduction: "Olá, sou Crypt0, escalador e criador do Run Into Me.",
  aboutCreatorStory: "Criei este site porque sou muito sociável e, entre uma parede e outra, sempre converso com outros escaladores. Acabei guardando números demais e gastando muito tempo livre organizando sessões.",
  aboutPlanningProblem: "Cansei de planejar e mandar mensagens individuais; queria avisar todos ao mesmo tempo quando e onde eu escalaria, sem um convite formal.",
  aboutDeveloperSolution: "Então lembrei que sou desenvolvedor e poderia criar a solução sozinho.",
  aboutWelcome: "Bem-vindo ao Run Into Me, um site para avisar seus amigos sobre atividades das quais eles podem participar sem pressão.",
  aboutCallToAction: "Na próxima vez que planejar uma atividade possível de fazer sozinho, mas mais divertida em grupo, publique-a aqui para seus amigos!",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "A tela Calendário também permite criar um novo evento.",
  aboutEventColorsIntroduction: "As cores indicam seu status de participação:",
  aboutColorGold: "Dourado",
  aboutColorGoldDescription: "Você está organizando este evento.",
  aboutColorGreen: "Verde",
  aboutColorGreenDescription: "Você participará deste evento.",
  aboutColorOrange: "Laranja",
  aboutColorOrangeDescription: "Você respondeu “talvez”.",
  aboutColorBlue: "Azul",
  aboutColorBlueDescription: "Você ainda não respondeu.",
  aboutColorGray: "Cinza",
  aboutColorGrayDescription: "Você recusou o convite.",
  aboutCalendarEventDetails: "Clique em um evento para ver mais informações e responder.",
  aboutFriendPageTitle: "Página de amigos",
  aboutFriendPageDescription: "Para adicionar um amigo, digite o usuário ou envie seu link de convite / código QR.",
  aboutHomePageTitle: "Página inicial",
  aboutHomePageDescription: "Veja os próximos eventos dos amigos e informe se você vai participar.",
  aboutRepostScreenTitle: "Tela de republicação",
  aboutGoogleCalendarDescription: "Use este botão para adicionar o evento ao Google Agenda.",
  aboutRepostDescription: "Depois de confirmar presença, você pode republicar o evento para seus amigos.",
};

export default ptBR;